import styled from 'styled-components'

export const Container = styled.section`
    float: left;
    width: 100%;
    position: relative;
    background-color: #0F1A2A;
    text-align: center;
    padding: 70px 60px;

    @media (max-width: 768px) {
        padding: 0 20px 40px 20px;
    }
`

export const ContainerInterno = styled.div`
    display: inline-block;
    max-width: 1100px;
`

export const TituloPrincipal = styled.span`
    float: left;
    width: 100%;
    color: #F09C00;
    font-size: 26px;
    font-weight: 600;
    margin: 0 0 30px 0;

    @media (max-width: 768px) {
        font-size: 22px;
    }
`

export const SubtituloPrincipal = styled.span`
    float: left;
    width: 100%;
    color: #fff;
    font-size: 26px;
    font-weight: 600;
    margin: 0 0 70px 0;
    line-height: 36px;

    @media (max-width: 768px) {
        font-size: 20px;
        line-height: 30px;
        margin: 0 0 30px 0;
    }
`

export const ListaPlanos = styled.div`
    float: left;
    width: 100%;
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 15px;

    @media (max-width: 1000px) {
        grid-template-columns: repeat(2, 1fr);
    }

    @media (max-width: 500px) {
        grid-template-columns: repeat(1, 1fr);
    }
`

export const ItemPlano = styled.div`
    
`

export const TagMelhorOferta = styled.div`
    display: flex;
    flex-direction: column;
    float: left;
    width: 100%;
    align-items: center;
    margin-bottom: 15px;
    min-height: 48px;

    @media (max-width: 768px) {
        min-height: 1px;
    }
`

export const TagMelhorOfertaIcone = styled.img`
    display: inline-block;
`

export const TagMelhorOfertaTexto = styled.span`
    color: #F09C00;
    font-size: 14px;
    font-weight: 600;
    margin-top: 5px;
`

export const BoxBorda = styled.div`
    float: left;
    width: 100%;
    border: solid 1px ${props => props.premium ? '#F09C00' : '#7D5200'};
    border-radius: 16px;
    padding: 10px;
`

export const TagEconomia = styled.span`
    float: left;
    width: 100%;
    background-color: ${props => props.premium ? '#F09C00' : '#7D5200'};
    color: #fff;
    text-align: center;
    border-radius: 8px;
    padding: 10px;
    font-size: 14px;
    font-weight: 600;
    margin: 0 0 20px 0;
`

export const TituloCard = styled.span`
    float: left;
    width: 100%;
    color: #fff;
    font-size: 22px;
    font-weight: 700;
    margin: 0 0 20px 0;
`

export const ListaBonus = styled.ul`
    float: left;
    width: 100%;
    margin: 0 0 20px 0;
    padding: 0;
    min-height: ${props => props.lote !== 4 ? '40px' : '0'};;

    @media (max-width: 500px) {
        min-height: 1px;
    }
`

export const ListaBonusLi = styled.li`
    float: left;
    width: 100%;
    color: #CBD4E1;
    list-style: none;
    font-size: 13px;
    line-height: 20px;
`

export const PrecoDe = styled.span`
    float: left;
    width: 100%;
    color: #E2E8F0;
    text-decoration: line-through;
    margin: 0 0 10px 0;
    font-size: 16px;
`

export const PrecoPor = styled.span`
    float: left;
    width: 100%;
    color: #fff;
    margin: 0 0 20px 0;
    font-size: 26px;
`

export const LinkCartao = styled.a`
    float: left;
    width: 100%;
    border-radius: 4px;
    padding: 7px 10px;
    color: ${props => props.premium ? '#F09C00' : '#fff'};
    border: solid 2px ${props => props.premium ? '#F09C00' : '#7D5200'};
    font-size: 13px;
    font-weight: 600;
    margin-bottom: 7px;
`

export const LinkBoleto = styled.a`
    float: left;
    width: 100%;
    border-radius: 4px;
    padding: 7px 10px;
    color: #fff;
    background-color: ${props => props.premium ? '#F09C00' : '#7D5200'};
    font-size: 13px;
    font-weight: 600;
`